module.exports = __webpack_public_path__ + "static/img/14000639.8df71ea7.png";